module.exports = __webpack_public_path__ + "images/12acdfaefd25b987eee480a1ab025566.svg";